import { useTranslation } from 'react-i18next'

import { FormFieldReadOnlyTextValue } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { TASK_FORM_UPDATED_FIELD_NAME } from '../../TaskForm.constants'

function UpdatedField() {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={FormFieldReadOnlyTextValue}
      fieldComponentProps={{
        label: `${t('Task.FormUpdatedFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={TASK_FORM_UPDATED_FIELD_NAME}
    />
  )
}

export default UpdatedField
